import camelcaseKeys from 'camelcase-keys';
import { z } from 'zod';

import { LocationIdSchema } from '@brightlocal/shared';

/** Request schema -- keys match API contract (kebab-case) */
export const CTCreateReportSettingsSchema = z.object({
  'location-id': LocationIdSchema,
  'business-type': z.string(),
  'primary-location': z.string()
});

export type CTCreateReportSettings = z.infer<typeof CTCreateReportSettingsSchema>;

export const CTCreateReportResponseSchema = z
  .object({
    status: z.string(),
    'report-id': z.number()
  })
  .transform((data) => camelcaseKeys(data));

export type CTCreateReportResponse = z.infer<typeof CTCreateReportResponseSchema>;
